import "@/index.css";
import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import { initUtmTracking } from "@/lib/utm";

import Home from "@/pages/Home";
import Metodo from "@/pages/Metodo";
import CaseStudies from "@/pages/CaseStudies";
import CaseStudyDetail from "@/pages/CaseStudyDetail";
import PerChiE from "@/pages/PerChiE";
import Verticale from "@/pages/Verticale";
import ChiSiamo from "@/pages/ChiSiamo";
import HiringScan from "@/pages/HiringScan";
import Contatti from "@/pages/Contatti";
import InformativaCandidati from "@/pages/InformativaCandidati";
import Admin from "@/pages/Admin";
import LandingAds from "@/pages/LandingAds";
import LandingAdsOffTarget from "@/pages/LandingAdsOffTarget";
import ThankYouInTarget from "@/pages/ThankYouInTarget";
import ThankYouOffTarget from "@/pages/ThankYouOffTarget";
import InvolveLandingFB from "@/pages/InvolveLandingFB";
import InternalHiringScan from "@/pages/InternalHiringScan";
import OptinScan from "@/pages/OptinScan";
import { PrivacyPolicy, CookiePolicy } from "@/pages/Policies";
import NotFound from "@/pages/NotFound";

function Shell() {
  const { pathname, search } = useLocation();
  const hideHeader = pathname.startsWith("/lp/") || pathname.startsWith("/tool/");
  const hideFooter = pathname === "/lp/prenota-call-fb" || pathname.startsWith("/tool/");

  // Re-run UTM capture on every route change: initUtmTracking() only writes
  // when the URL carries utm_* params, so internal navigations are no-ops.
  useEffect(() => {
    initUtmTracking();
  }, [pathname, search]);

  return (
    <>
      {!hideHeader && <Header />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/metodo" element={<Metodo />} />
          <Route path="/casi-studio" element={<CaseStudies />} />
          <Route path="/casi-studio/:slug" element={<CaseStudyDetail />} />
          <Route path="/per-chi-e" element={<PerChiE />} />
          <Route path="/per-chi-e/:vertical" element={<Verticale />} />
          <Route path="/chi-siamo" element={<ChiSiamo />} />
          <Route path="/hiring-scan" element={<HiringScan />} />
          <Route path="/contatti" element={<Contatti />} />
          <Route path="/informativa-candidati" element={<InformativaCandidati />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/lp/prenota-call" element={<LandingAds />} />
          <Route path="/lp/prenota-call/off-target" element={<LandingAdsOffTarget />} />
          <Route path="/lp/grazie/in-target" element={<ThankYouInTarget />} />
          <Route path="/lp/grazie/fuori-target" element={<ThankYouOffTarget />} />
          <Route path="/lp/prenota-call-fb" element={<InvolveLandingFB />} />
          <Route path="/tool/hiring-scan" element={<InternalHiringScan />} />
          <Route path="/lp/hiring-scan" element={<OptinScan />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {!hideFooter && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App min-h-screen flex flex-col">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Shell />
        </BrowserRouter>
      </HelmetProvider>
      <Toaster position="bottom-center" theme="light" />
    </div>
  );
}

export default App;
